export function HireBenefits({ className }: { className: string }) {
    return <ul className={className} aria-label="Hire benefits">
        <li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 13v-1a8 8 0 0 1 16 0v1M4 12H3v7h4v-7ZM20 12h1v7h-4v-7ZM20 19c0 2-3 3-7 3" /><path d="M10 21h3v2h-3" /></svg><span>7-day support</span></li>
        <li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 8 3v6c0 5-8 9-8 9S4 17 4 12V6Z" /><path d="m8 12 3 3 5-6" /></svg><span>Fully insured</span></li>
        <li><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><rect x="9" y="7" width="6" height="10" rx="3" /></svg><span>No security deposit</span></li>
    </ul>
}
